export default __webpack_public_path__ + "static/futuremodel-ec194c3f7bee3be16543dca3d6f9d157.png";